(function () {
  'use strict';
  if (window.roccoKachingPiecePrice) return;
  window.roccoKachingPiecePrice = true;
  var states = new WeakMap();
  var priceSelector = '.kaching-bundles__bar-unit-price';
  var pieceClass = 'rocco-kaching-piece-price';

  function moneyAmount(text) {
    // Kaching's money format follows the store, not necessarily the page language.
    var value = text.replace(/[^0-9.,]/g, '');
    var decimalIndex = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
    var decimals = value.length - decimalIndex - 1;
    if (decimalIndex >= 0 && decimals > 0 && decimals <= 2) {
      value = value.slice(0, decimalIndex).replace(/[.,]/g, '') + '.' + value.slice(decimalIndex + 1);
    } else {
      value = value.replace(/[.,]/g, '');
    }
    return value && /^\d+(\.\d+)?$/.test(value) ? Number(value) : NaN;
  }

  function update(widget) {
    if (!widget.isConnected || !widget.dealBlock || !widget.config) return;
    if (!document.getElementById('rocco-kaching-piece-price-styles')) {
      var style = document.createElement('style');
      style.id = 'rocco-kaching-piece-price-styles';
      style.textContent = '[data-rocco-piece-source]{display:none!important}.kaching-bundles .rocco-kaching-piece-price{text-transform:none}';
      document.head.appendChild(style);
    }
    var locale = document.documentElement.lang || 'de';
    var language = locale.toLowerCase().split('-')[0];
    var labels = { de: 'Stück', it: 'pz', en: 'piece' };
    var currency = widget.config.marketCurrencyCode || 'EUR';
    var formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    widget.querySelectorAll('.' + pieceClass).forEach(function (piece) {
      if (!piece.previousElementSibling || !piece.previousElementSibling.matches(priceSelector + '[data-rocco-piece-source]')) piece.remove();
    });
    widget.querySelectorAll(priceSelector + ':not(.' + pieceClass + ')').forEach(function (source) {
      var bar = source.closest('.kaching-bundles__bar[data-deal-bar-id]');
      if (!bar) return;
      var deal = (widget.dealBlock.dealBars || []).find(function (item) { return item.id === bar.dataset.dealBarId; });
      if (!deal || (deal.dealBarType && deal.dealBarType !== 'quantity-break' && deal.dealBarType !== 'bxgy')) return;
      // Only replace the bar's main unit-price row, never mixed-bundle product rows.
      if (!source.closest('.kaching-bundles__bar-pricing')) return;
      var quantity = Number(deal.quantity);
      if (deal.quantitySelector && bar.classList.contains('kaching-bundles__bar--selected')) quantity = Number(widget.quantity) || quantity;
      var total = bar.querySelector('.kaching-bundles__bar-pricing .kaching-bundles__bar-price');
      if (!total || !Number.isFinite(quantity) || quantity <= 0) return;
      var amount = moneyAmount(total.textContent);
      if (!Number.isFinite(amount)) return;
      // Kaching can already display per-item main prices; never divide those twice.
      var perPiece = widget.dealBlock.showPricesPerItem ? amount : amount / quantity;
      var text = formatter.format(Math.round((perPiece + Number.EPSILON) * 100) / 100) + ' / ' + (labels[language] || labels.en);
      var piece = source.nextElementSibling;
      if (!piece || !piece.classList.contains(pieceClass)) {
        piece = document.createElement('div');
        piece.className = 'kaching-bundles__bar-unit-price ' + pieceClass;
        source.insertAdjacentElement('afterend', piece);
      }
      if (piece.textContent !== text) piece.textContent = text;
      // Keep the original in the DOM: the upper PDP price still needs its liter price.
      source.setAttribute('data-rocco-piece-source', '');
    });
  }

  function schedule(widget) {
    if (widget.closest('kaching-bundles-sticky-atc')) return;
    var state = states.get(widget);
    if (!state) {
      state = { queued: false };
      states.set(widget, state);
      new MutationObserver(function () { schedule(widget); }).observe(widget, { childList: true, subtree: true, characterData: true });
    }
    if (state.queued) return;
    state.queued = true;
    requestAnimationFrame(function () { state.queued = false; update(widget); });
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('kaching-bundles-block')) schedule(root);
    root.querySelectorAll('kaching-bundles-block').forEach(schedule);
  }
  ['variants-changed', 'deal-bar-selected', 'kaching-bundles-block-hydrated'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (event.target.matches && event.target.matches('kaching-bundles-block')) schedule(event.target);
    }, true);
  });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  new MutationObserver(function (records) {
    records.forEach(function (record) { record.addedNodes.forEach(scan); });
  }).observe(document, { childList: true, subtree: true });
  scan(document);
})();
